/* THUNDER HONEY V3, Shopify theme only. Never ported, edit it here. Loaded (defer) by snippets/th-v3-head.

   The Shopify side of _deploy_baseline/_v3/reviews.js. On thunderhoney.co that file fetches the shop's product page for
   the Judge.me figures. Here Liquid already has them: snippets/th-v3-reviews-data prints them once as
     <script type="application/json" id="th-v3-rv">{"avg":"4.85","count":72,"h":[64,6,1,1,0]}</script>
   and this file writes them into every marked figure, with the same markers the static pages use:
     data-rv="avg|count|pct5|pct45"          the element's text (and its data-count, when motion.js counts it up)
     data-rv-p="p5|p45|pavg"                 the --p bar width (0-1)
     data-rv-aria="Rated {avg} out of 5"     the aria-label, from a template with {avg} {count} {pct5} {pct45}
   Sections print the same figures in Liquid too, so they are right without JavaScript; this only touches what is marked
   and leaves what already matches alone. No network request. pct5, pct45, p5 and p45 need the histogram (h, 5 stars
   down to 1) and stay as printed when it is missing. Rounding is the static build's: half up, whole percent. */
(function () {
  'use strict';
  var d = document, root = d.documentElement;
  var src = d.getElementById('th-v3-rv');
  if (!src || !d.querySelector('[data-rv],[data-rv-p],[data-rv-aria]')) return;

  var v;
  try { v = JSON.parse(src.textContent); } catch (e) { return; }
  var n = +v.count;
  if (!n || !v.avg) return;

  var x = { avg: String(v.avg), count: String(n), pavg: (parseFloat(v.avg) / 5).toFixed(3).replace(/^0/, '') };
  var h = v.h;
  if (h && h.length === 5 && h[0] + h[1] + h[2] + h[3] + h[4] === n) {
    var pct5 = Math.floor(100 * h[0] / n + 0.5), pct45 = Math.floor(100 * (h[0] + h[1]) / n + 0.5);
    x.pct5 = String(pct5); x.pct45 = String(pct45);
    x.p5 = (pct5 / 100).toFixed(2).replace(/^0/, ''); x.p45 = (pct45 / 100).toFixed(2).replace(/^0/, '');
  }

  [].forEach.call(d.querySelectorAll('[data-rv]'), function (el) {
    var val = x[el.getAttribute('data-rv')];
    if (val == null) return;
    if (el.hasAttribute('data-count')) {
      if (el.getAttribute('data-count') !== val) el.setAttribute('data-count', val);
      var c = el.__ct; /* motion.js counter: a running or waiting count now ends on this figure */
      if (c) { c.to = parseFloat(val); if (c.done || c.last === '') el.textContent = c.fmt(c.to); return; }
    }
    if (el.textContent !== val) el.textContent = val;
  });
  [].forEach.call(d.querySelectorAll('[data-rv-p]'), function (el) {
    var val = x[el.getAttribute('data-rv-p')];
    if (val != null && el.style.getPropertyValue('--p') !== val) el.style.setProperty('--p', val);
  });
  [].forEach.call(d.querySelectorAll('[data-rv-aria]'), function (el) {
    var label = el.getAttribute('data-rv-aria').replace(/\{(\w+)\}/g, function (m, k) { return x[k] != null ? x[k] : m; });
    if (label.indexOf('{') < 0 && el.getAttribute('aria-label') !== label) el.setAttribute('aria-label', label);
  });
  root.setAttribute('data-rv-live', x.avg + '|' + x.count);
})();
